<script setup lang="ts">
import { getTranslatedProperty } from '@shopware-pwa/helpers-next';
import type { Schemas } from '@shopware/api-client/api-types/storeApiTypes';

const props = defineProps<{
    manufacturer?: Schemas['ProductManufacturer'];
}>();

const { getCategoryLink } = useVendor();
const categoryLink = await getCategoryLink(props.manufacturer?.id);
</script>

<template>
    <div
        v-if="manufacturer && manufacturer.media"
        class="flex-shrink-0"
    >
        <LocaleLink
            v-if="categoryLink"
            :to="categoryLink"
        >
            <img
                v-if="manufacturer.media"
                :src="manufacturer.media.url"
                :alt="getTranslatedProperty(manufacturer, 'name')"
                class="h-8 w-auto md:h-10"
            />
        </LocaleLink>
        <template v-else>
            <img
                v-if="manufacturer.media"
                :src="manufacturer.media.url"
                :alt="getTranslatedProperty(manufacturer, 'name')"
                class="h-8 w-auto md:h-10"
            />
        </template>
    </div>
</template>
